import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type KeyPermissionsType = 'read' | 'read:write';

type PermissionsToggleProps = {
  selectedPermission: KeyPermissionsType;
  onPermissionChange: (permission: KeyPermissionsType) => void;
};

export const PermissionsToggle = ({
  selectedPermission,
  onPermissionChange,
}: PermissionsToggleProps) => {
  const theme = useTheme(); // Get the MUI v5 theme

  const handlePermissionChange = (
    event: React.MouseEvent<HTMLElement>,
    newPermission: KeyPermissionsType
  ) => {
    if (newPermission !== null) {
      onPermissionChange(newPermission);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
      }}
    >
      <ToggleButtonGroup
        value={selectedPermission}
        exclusive
        onChange={handlePermissionChange}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 4,
          height: 30,
        }}
      >
        <ToggleButton
          value="read:write"
          sx={{
            borderRadius: 4,
            height: 30,
            '&.Mui-selected': {
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
            },
          }}
        >
          read:write
        </ToggleButton>
        <ToggleButton
          value="read"
          sx={{
            borderRadius: 4,
            height: 30,
            '&.Mui-selected': {
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
            },
          }}
        >
          read
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
